import { Container, Divider, Space, Text, Title } from "@mantine/core";
import I18n from "../../i18n.js";
import parse from "html-react-parser";

interface LegalPageProps {
  id: string;
}

export default function LegalPage({ id }: LegalPageProps) {
  return (
    <Container size="md" py="xl">
      <Title>{I18n.t(`legal.${id}.heading`)}</Title>
      <Space h="md" />
      <Divider />
      <Space h="md" />
      <Text>{parse(I18n.t(`legal.${id}.text`))}</Text>
    </Container>
  );
}
